/**
 * Cấu hình app — đọc từ .env (build-time):
 *   - .env.development: dev local
 *   - .env.production:  build deploy
 *
 * Branding fields (logo, tên trường, support contacts) cho phép reskin nhanh
 * khi deploy cho institution khác (HAU, SGU, DHCNTT...) mà không sửa code.
 */
const apiOrigin = process.env.REACT_APP_API_URL || "http://localhost:5100";

export const appConst = {
    /** Origin (không slash cuối) — dùng cho SignalR hub URL etc. */
    apiOrigin,
    /** Base URL cho REST API — đã include `/api`. */
    baseApiURL: `${apiOrigin}/api`,

    branding: {
        webName: process.env.REACT_APP_WEB_NAME || "Học viện Tài Chính",
        tagline: process.env.REACT_APP_TAGLINE || "Cổng đăng ký tín chỉ",
        /** Logo HVTC chính thức từ SSO endpoint — fallback default nếu env không set. */
        logoUrl:
            process.env.REACT_APP_LOGO_URL ||
            "https://main.hvtc.edu.vn/images/logo.png",
        instructionsLink: process.env.REACT_APP_INSTRUCTIONS_LINK || "",
        copyright: process.env.REACT_APP_COPYRIGHT || "© 2026 All Rights Reserved",
    },

    contact: {
        address: process.env.REACT_APP_ADDRESS || "",
        email: process.env.REACT_APP_EMAIL || "",
        hotline: process.env.REACT_APP_HOTLINE || "",
        fax: process.env.REACT_APP_FAX || "",
        website: process.env.REACT_APP_WEBSITE || "",
    },

    support: {
        daoTao: {
            name: process.env.REACT_APP_SUPPORT_DAOTAO_NAME || "Ban Quản lý đào tạo",
            email: process.env.REACT_APP_SUPPORT_DAOTAO_EMAIL || "",
            phone: process.env.REACT_APP_SUPPORT_DAOTAO_PHONE || "",
        },
        tech: [
            {
                name: process.env.REACT_APP_SUPPORT_TECH_1_NAME || "",
                phone: process.env.REACT_APP_SUPPORT_TECH_1_PHONE || "",
            },
            {
                name: process.env.REACT_APP_SUPPORT_TECH_2_NAME || "",
                phone: process.env.REACT_APP_SUPPORT_TECH_2_PHONE || "",
            },
            {
                name: process.env.REACT_APP_SUPPORT_TECH_3_NAME || "",
                phone: process.env.REACT_APP_SUPPORT_TECH_3_PHONE || "",
            },
        ].filter(t => t.name),
    },
};
